import { RequestConvertQuoteParameter, requestConvertQuoteSendEmailAPI } from "@crescentParts/Services/RequestCovertQuoteService";
import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { RequestConvertQuoteModel } from "@crescentParts/Widgets/CustomApiModels";
import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type Parameter = RequestConvertQuoteParameter & HasOnSuccess<RequestConvertQuoteModel>;

type Props = {
    apiParameter: Parameter;
    apiResult: RequestConvertQuoteModel;
};

type HandlerType = CustomHandler<Parameter, Props>

export const DispatchBeginEmailSend: HandlerType = props => {
    props.dispatch({
        type: "Custom/RequestConvertQuote/BeginEmailSend"
    });
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await requestConvertQuoteSendEmailAPI(props.parameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const DispatchCompleteEmailSend: HandlerType = props => {
    props.dispatch({
        type: "Custom/RequestConvertQuote/CompleteEmailSend"
    });
};

export const chain = [DispatchBeginEmailSend, SendDataToApi, ExecuteOnSuccessCallback, DispatchCompleteEmailSend];

const requestConvertQuoteSendEmail = createHandlerChainRunner(chain, "requestConvertQuoteSendEmail");
export default requestConvertQuoteSendEmail;